export const GMB_LOGO_URL = "https://gmb-public.s3.us-east-2.amazonaws.com/logos/GMB_192.png";